'use client';

import { cn } from '@/lib/utils';
import { ReactNode, useEffect, useState } from 'react';

interface TabBarProps {
  value?: string;
  tabItems: Array<{ label: ReactNode; value: string; disabled?: boolean }>;
  onChange: (tab: string) => void;
  defaultValue?: string;
  warpperClassName?: string;
  tabItemClassName?: string;
  activeClassName?: string;
}
export default function TabBar(props: TabBarProps) {
  const {
    value,
    tabItems,
    onChange,
    defaultValue,
    warpperClassName,
    tabItemClassName,
    activeClassName,
  } = props;
  const [activetab, setActiveTab] = useState<string>(value || defaultValue || tabItems[0].value);

  const handleTabChange = (tab: string) => {
    onChange(tab);
    setActiveTab(tab);
  };

  useEffect(() => {
    if (value) {
      setActiveTab(value);
    }
  }, [value]);

  return (
    <div className="flex">
      <div className={cn('rounded-xl flex items-center p-1 gap-2 bg-[#1A1A1A]', warpperClassName)}>
        {tabItems.map((item) => (
          <button
            key={item.value}
            value={item.value}
            disabled={item.disabled}
            className={cn(
              'text-sm font-medium transition-colors rounded-none px-6 py-2 capitalize',
              'flex items-center justify-center text-white rounded-[10px] bg-transparent',
              tabItemClassName,
              {
                'text-[#697479]': activetab !== item.value,
                'bg-[#2A2A2A]': activetab === item.value,
                'cursor-not-allowed opacity-50': item.disabled,
              },
              activetab === item.value ? activeClassName : '',
            )}
            onClick={() => handleTabChange(item.value)}
          >
            {item.label}
          </button>
        ))}
      </div>
    </div>
  );
}
